import * as React from 'react';
import styled from 'styled-components';
import { DiagramLabelCompletionQuestionResult } from './DiagramLabelCompletionResult';

export const FLowChartComplexResult = (props) => {
  return <Main {...props} />;
};

const Main = styled(DiagramLabelCompletionQuestionResult)`
  .paragraph-blank:not(:first-child) {
    margin-top: 16px;
  }
`;
